var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.834 284.511H43.2217M122.528 205.205V363.817",
    stroke: "white",
    strokeWidth: 79.3061,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M262.899 125.898C295.022 89.9839 337.293 64.6694 384.118 53.3047C430.943 41.9399 480.115 45.0607 525.128 62.2539C570.14 79.4472 608.871 109.903 636.196 149.59C663.521 189.277 678.151 236.326 678.151 284.511C678.151 332.695 663.521 379.744 636.196 419.431C608.871 459.119 570.14 489.574 525.128 506.767C480.115 523.96 430.943 527.081 384.118 515.716C337.293 504.352 295.022 479.037 262.899 443.123",
    stroke: "white",
    strokeWidth: 79.3061,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M283.519 468.897C235.46 491.138 194.767 526.663 166.241 571.278C137.716 615.894 122.548 667.738 122.527 720.694C122.527 731.21 126.705 741.296 134.141 748.733C141.578 756.169 151.664 760.347 162.18 760.347H717.323C727.839 760.347 737.925 756.169 745.362 748.733C752.798 741.296 756.976 731.21 756.976 720.694C756.921 667.695 741.694 615.82 713.095 571.2C684.496 526.58 643.72 491.081 595.588 468.897",
    stroke: "white",
    strokeWidth: 79.3061,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAddUser);
export default __webpack_public_path__ + "static/media/ico_add_user.c1da816fdabbcffde959d509c4297c4c.svg";
export { ForwardRef as ReactComponent };